export function saveItem(name: string, content: any, isString?: boolean) {
  if (isString) localStorage.setItem(name, content);
  else localStorage.setItem(name, JSON.stringify(content));
}

export function loadItem(name: string, isString?: boolean) {
  const data = localStorage.getItem(name);
  if (isString) return data;
  if (data !== null) return JSON.parse(data);
  else return null;
}

export function clearStorage() {
  return localStorage.clear();
}
